import type { Module, ActionContext } from 'vuex';

import {
    SET_SIGN_UP_STEP,
    SET_REGILY_OPEN_STATE,
    SET_BANK_LINKING_COMPLETION,
} from './account.constants';
import type { IAccountState } from './account.constants';
import type { IAppState } from '../../constants';

export const getters = {
    signUpStep(state: IAccountState) {
        return state.step;
    },
    isRegilyOpen(state: IAccountState) {
        return state.isRegilyOpen;
    },
    hasCompletedBankLinking(state: IAccountState) {
        return state.hasCompletedBankLinking;
    },
};

export const actions = {
    setSignUpStep(
        { commit }: ActionContext<IAccountState, IAppState>,
        step: number,
    ) {
        commit(SET_SIGN_UP_STEP, step);
    },
    setRegilyOpenState(
        { commit }: ActionContext<IAccountState, IAppState>,
        isOpen: boolean,
    ) {
        commit(SET_REGILY_OPEN_STATE, isOpen);
    },
    setBankLinkingCompletion(
        { commit }: ActionContext<IAccountState, IAppState>,
        isCompleted: boolean,
    ) {
        commit(SET_BANK_LINKING_COMPLETION, isCompleted);
    },
};

export const account: Module<IAccountState, IAppState> = {
    namespaced: true,
    state: {
        step: 1,
        isRegilyOpen: false,
        hasCompletedBankLinking: false,
    },
    getters,
    actions,
    mutations: {
        [SET_SIGN_UP_STEP](state, step: number) {
            state.step = step;
        },
        [SET_REGILY_OPEN_STATE](state, isOpen: boolean) {
            state.isRegilyOpen = isOpen;
        },
        [SET_BANK_LINKING_COMPLETION](state, isCompleted: boolean) {
            state.hasCompletedBankLinking = isCompleted;
        },
    },
};
